/* eslint-disable import/prefer-default-export */
function isExpired(expires) {
  const expirationDate = new Date(expires);
  const now = new Date();
  return now - expirationDate >= 0;
}
let apiEnv = 'production';

function getKey(key) {
  return `${key}_h5_${(window.env && window.env.VUE_APP_ENV) || apiEnv}`;
}

export class Storage {
  static getItem(key) {
    const storageVal = localStorage.getItem(getKey(key));
    if (storageVal) {
      const data = JSON.parse(storageVal);
      if (data.expires && isExpired(data.expires)) {
        this.removeItem(key);
        return null;
      }
      return data.val;
    }
    return null;
  }

  static removeItem(key) {
    return localStorage.removeItem(getKey(key));
  }

  static setItem(key, val, expirationDate) {
    if (val !== undefined) {
      const data = {
        expires: expirationDate && expirationDate.toGMTString(),
        val,
      };
      return localStorage.setItem(getKey(key), JSON.stringify(data));
    }
    return undefined;
  }

  /**
   * 设置多少小时后过期
   * @param {*} key
   * @param {*} val
   * @param {*} hour
   */
  static setItemExpiresHour(key, val, hour) {
    let expirationDate = '';
    if (typeof hour !== 'undefined') {
      expirationDate = new Date(hour * 60 * 60 * 1000 + (new Date()).getTime());
    }
    Storage.setItem(key, val, expirationDate);
  }

  static setApiEnv(env) {
    apiEnv = env;
  }
}
